// extracted by mini-css-extract-plugin
module.exports = {"Item":"Navitems_Item__MG0DA","active":"Navitems_active__20l8I"};